
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const statusPaid = computed(() => {
      const isLogged = store.getters["user/isLogged"];
      if (isLogged) return store.getters["user/isPaid"];
      return false;
    });

    const isOnlineRegistractionActive = computed(() => {
      return store.getters["user/checkIfRegisterOnlineIsEnabled"];
    });

    function goTo(to, ticket) {
      router.push({ name: to, query: { ticketId: ticket } });
    }

    return { eventData, goTo, statusPaid, isOnlineRegistractionActive };
  },
};
